export const useUrlParams = () => {
  const path = window.location.pathname;
  const parts = path.split("/");
  const key = parts[parts.length - 1];
  return { key };
};
